
// @ts-nocheck
import locale__app__app_lang_nl_json from "../lang/nl.json";
import locale__app__app_lang_en_json from "../lang/en.json";


export const localeCodes =  [
  "nl",
  "en",
  "fr"
]

export const localeLoaders = {
  "nl": [{ key: "../lang/nl.json", load: () => Promise.resolve(locale__app__app_lang_nl_json), cache: true }],
  "en": [{ key: "../lang/en.json", load: () => Promise.resolve(locale__app__app_lang_en_json), cache: true }],
  "fr": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "nl",
      "domain": "https://feestfiets.be",
      "iso": "nl-BE",
      "name": "nl",
      "files": [
        "lang/nl.json"
      ]
    },
    {
      "code": "en",
      "domain": "https://beerbike.be",
      "iso": "en-GB",
      "name": "en",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "fr",
      "domain": "https://feestfiets.be",
      "iso": "fr-FR",
      "name": "fr"
    }
  ],
  "defaultLocale": "nl",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://feestfiets.be",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "nl",
    "domain": "https://feestfiets.be",
    "iso": "nl-BE",
    "name": "nl",
    "files": [
      {
        "path": "lang/nl.json"
      }
    ]
  },
  {
    "code": "en",
    "domain": "https://beerbike.be",
    "iso": "en-GB",
    "name": "en",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "fr",
    "domain": "https://feestfiets.be",
    "iso": "fr-FR",
    "name": "fr",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
